export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

export function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;
  const mobileTrigger = getWindowSize(800);

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit:first').attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');

    if (!mobileTrigger) {
      $searchBox.attr('tabindex', '0');
    }
  }
}

export function updateWeatherFeatureFormat() {
  setInterval(function () {
    let str = $('#weatherBugDescription').text();
    let weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
    if (weatherBugSet || str == '') return;
    $('#weatherBugWidget').addClass('weatherBugSet');
    let findSpace = str.lastIndexOf(' ');
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
    $('#weatherBugWidget').css('opacity', 1);
  }, 1000);
}

export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 995px)');
    const additionalValue = mq.matches ? 0 : 40;
    const content = $('.content');
    const isHomepage = $('body').hasClass('homepage');

    content.css(
      'margin-top',
      isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
    );
  }
  applyMargin();

  $(globalThis).on('resize', applyMargin);

  $(globalThis).on('scroll', function () {
    if ($(this).scrollTop() === 0) {
      setTimeout(applyMargin, 300);
    }
  });
}

export function updateSocialWidgetPosition() {
  function moveSocialWidget() {
    const isMobile = $('body').hasClass('saffireMobileSize');
    let $socialWidget = $('.header .socialNetworks');

    if (isMobile) {
      $socialWidget.appendTo('.footer');
    } else {
      $socialWidget = $('.footer .socialNetworks');
      $socialWidget.appendTo('.header .headerInnerContent');
    }
  }

  moveSocialWidget();
  $(globalThis).on('resize', moveSocialWidget);
}
